if (!customElements.get('theme-group')) {
  customElements.define('theme-group', class extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('theme-group--split')) return;
      this.updateSplit();
      this.observer = new MutationObserver(() => this.updateSplit());
      this.observer.observe(this, { childList: true });
    }

    updateSplit() {
      const count = [...this.children].filter((child) => !child.matches('style, script, link, template, .theme-group__link')).length;
      const settings = getComputedStyle(this);
      const first = Number(settings.getPropertyValue('--group-split-first')) || 1;
      const rest = Number(settings.getPropertyValue('--group-split-rest')) || 1;
      const others = Math.max(1, count - 1);
      this.style.setProperty('--group-split-template', count < 2 ? 'minmax(0, 1fr)' : `minmax(0, ${first * others}fr) repeat(${others}, minmax(0, ${rest}fr))`);
      this.style.setProperty('--split-first-grow', String(first * others));
    }

    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
